export default "__VITE_ASSET__CAMkpxGG__"